import axios from "axios";
import { API_URL } from "../config/axiosConfig";

export const apiGetBatchByDate = (token, date) =>
  axios.get(`${API_URL}/v1/batchRecord/date/${date}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
export const apiGetBatchToday = (token) =>
  axios.get(`${API_URL}/v1/batchRecord/date/today`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const apiGetTransactionsByBatch = (token, batchId) =>
  axios.get(`${API_URL}/v1/batchRecord/batchId/${batchId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const apiVerifyBatch = (token, batchId) =>
  axios.post(
    `${API_URL}/v1/batchRecord/${batchId}/status/VERIFIED`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
